import React,{useState,useEffect} from 'react';
import {Navigate} from 'react-router-dom';
import {supabase} from '../../supabaseClient';

const AuthGuard=({children}) => {
  const [authStatus,setAuthStatus]=useState('loading'); // 'loading' | 'authenticated' | 'needs-profile' | 'needs-code' | 'unauthenticated'

  useEffect(() => {
    const checkAuth=async () => {
      try {
        // Check if user is authenticated
        const {data: {user}, error: authError}=await supabase.auth.getUser();
        if (authError || !user) {
          setAuthStatus('unauthenticated');
          return;
        }

        // Check if trainer has a profile
        const {data: profile, error: profileError}=await supabase
          .from('trainer_profiles')
          .select('*')
          .eq('user_id',user.id)
          .single();

        if (profileError && profileError.code !=='PGRST116') {
          console.error('Profile check error:', profileError);
          setAuthStatus('unauthenticated');
          return;
        }

        if (!profile) {
          setAuthStatus('needs-profile');
          return;
        }

        // Check if access code is verified in this session
        const sessionCodeVerified=sessionStorage.getItem('trainerAccessVerified')==='true';
        const sessionProfileId=sessionStorage.getItem('trainerProfileId');

        if (sessionCodeVerified && sessionProfileId===profile.id) {
          setAuthStatus('authenticated');
        } else {
          setAuthStatus('needs-code');
        }
      } catch (error) {
        console.error('Auth check error:', error);
        setAuthStatus('unauthenticated');
      }
    };
    checkAuth();
  }, []);

  if (authStatus==='loading') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-8 w-8 bg-indigo-600 rounded-full mb-4 animate-bounce"></div>
          <p className="text-gray-500 font-medium">Verifying access...</p>
        </div>
      </div>
    );
  }

  if (authStatus==='unauthenticated') {
    return <Navigate to="/trainer-login" replace />;
  }

  if (authStatus==='needs-profile') {
    return <Navigate to="/complete-trainer-profile" replace />;
  }

  if (authStatus==='needs-code') {
    return <Navigate to="/trainer-login" replace />;
  }

  if (authStatus==='authenticated') {
    return <>{children}</>;
  }

  return null;
};

export default AuthGuard;